import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { ChannelId } from '@business/entities/SupportChannel';
import { SupportChannelAPI } from '@business/api/SupportChannel';
import { SupportChannelRuleResponse } from '@business/entities/SupportChannel';
import { SupportChannelRuleRequest, ChannelRuleId } from '@business/entities/SupportChannel/SupportChannelRuleResponse';

export class SupportChannelRuleBloc extends BaseBloc {
  private readonly ruleRepo = new Repository<SupportChannelRuleResponse>({
    getItemId: item => item.id,
  });

  readonly rules$ = this.ruleRepo.items$;
  readonly selectItem = this.ruleRepo.selectItem;

  onReset() {
    this.ruleRepo.reset();
  }

  fetchChannelRules = (id: ChannelId) => {
    return SupportChannelAPI.fetchChannelRules(id).pipe(
      this.ruleRepo.ops.reset(),
      //this.ruleRepo.ops.upsertMany(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_channels_error') }),
    );
  };

  createChannelRule = (id: ChannelId, data: SupportChannelRuleRequest) => {
    return SupportChannelAPI.createChannelRule(id, data).pipe(
      this.ruleRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_channel'),
      }),
    );
  };

  updateChannelRule = (id: ChannelRuleId, data: SupportChannelRuleRequest) => {
    return SupportChannelAPI.updateChannelRule(id, data).pipe(
      this.ruleRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_channel'),
      }),
    );
  };

  deleteChannelRule = (id: ChannelRuleId) => {
    return showDeleteConfirmation('Delete Channel', 'Do you really want to remove this channel urle?').pipe(
      switchMap(() => SupportChannelAPI.deleteChannelRule(id)),
      this.ruleRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_channel'),
      }),
    );
  };
}
